export class EventService {
  constructor($http, $cookies) {
    this.http = $http;
    this.cookies = $cookies;
  }

  getEvents(page, limit) {
    return this.http.get('/api/event/' + page + '/' + limit + '/');
  }

  createEvent(newEvent) {
    return this.http.post('/api/event', newEvent)
  }

  getTypes() {
    return this.http.get('/api/category/events');
  }

  getMyEvents(page, limit) {
    return this.http.get('/api/event/my/' + page + '/' + limit + '/');
  }

  getMyRegistredEvents(page, limit) {
    return this.http.get('/api/event/my/register/' + page + '/' + limit + '/');
  }

  getPastEvents(page, limit) {
    return this.http.get('/api/event/past/' + page + '/' + limit + '/');
  }

  getEventUsers(request) {
    return this.http.post(`/api/event/event-users`, request);
  }

  getAllEvents(page, limit, query) {
    var params = {
      page: page,
      limit: limit,
      query: query || {}
    }

    return this.http.post('/api/events/filter', params)
  }

  getEventById(id){
    return this.http.get('/api/event/'+id);
  }

  subscribeToEvent(eventID, userID){
    return this.http.put('/api/event/', {userID: userID, eventID: eventID})
  }

  eventCoverByType(type){
    let coverImg = '';

    switch (type){
      case '1':
        coverImg = 'images/events/fiesta.jpg';
        break;
      case '2':
        coverImg = 'images/events/carrete.jpg';
        break;
      case '3':
        coverImg = 'images/events/asado.jpg';
        break;
      case '4':
        coverImg = 'images/events/junta.jpg';
        break;
      case '5':
        coverImg = 'images/events/eventocultural.jpg';
        break;
      default:
        coverImg = 'images/events/otro.jpg';
        break;
    }
    return coverImg;
  }

  getUnconfirmedEvents(page, limit) {
    return this.http.get('/api/events/unconfirmed/'+page+'/'+limit);
  }

  approveEvents(id) {
    return this.http.get('/api/events/approve/'+id);
  }

  rejectEvents(id, message) {
    return this.http.put('/api/events/reject/'+id, message);
  }

  removeEvents(id) {
    return this.http.delete('/api/event/'+id);
  }

  updateEvent(event) {
    return this.http.put('/api/event/' + event._id, event);
  }
}
